module.exports = function() {
	return new Worker(__webpack_public_path__ + "24e0a46ae215c3d10e82.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./scripts/workers/sway.worker.js
// module id = 383
// module chunks = 0